import './style.scss'
import { useContext, useState } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { AppSpan, AppText, Circle, CustomContainer, FixedContainer, FlexRow, GridContainer, SidePopupContainer } from "src/style"
import UserIcon from 'src/assets/svg/user-icon'
import LogoutIcon from 'src/assets/svg/logout-icon'
import { useNavigate } from 'react-router-dom'
import ProfilePics from 'src/assets/img/profile-pics.jpg'

export const AccountAction: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {info: {userData, userType}, setInfoProperty} = useContext(AppInfoContext)
    const {decisionBox} = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState<any>({user: false, logout: false})
    const {logout} = useContext(AppInfoContext)

    const firstName = userData?.firstName || 'John'
    const lastName = userData?.firstName ? userData?.lastName : 'Doe'

    async function handleViewProfile() {
        navigate('/general/rofile')
        close()
    }

    function handleConfirmLogout () {
        decisionBox.show(
            `Are you sure you want to log out?`,
            handleLogout,
            decisionBox.hide,
            `Yes, Logout`,
            'No'
        )

        close()
    }

    async function handleLogout() {
        await logout()
        navigate('/')
    }
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='transparent' />
            <FixedContainer zIndex="8" top='8' right='2' className="acct-action-container">
                <CustomContainer
                    width="24" 
                    minHeight='15' topPadding='1' bottomPadding='1'
                    bgColor="#ffffff" radius="0.8"
                    shadow="0px 4px 10px 0px #0000000D"
                    className='acct-action-content-container'
                >
                    <FlexRow 
                        justifyContent='flex-start' alignItems='flex-start'
                        leftPadding='1.5' rightPadding='1.5' gap='1'
                        wrap='wrap' bottomMargin='1'
                    >
                        <Circle 
                            size="4" //bgColor='#F9FAFB'
                            bgColor='#0A756F'
                            style={{overflow: 'hidden'}}
                        >
                            {/* <img src={ProfilePics} className='img-covered' /> */}
                            <AppText textSize='1.7' color='#ffffff' fontWeight='600'>{firstName?.[0]}{lastName?.[0]}</AppText>
                        </Circle>
                        <CustomContainer width='auto' sizeUnit=''>
                            <AppSpan fontWeight='600' color='#344054'>{firstName} {lastName}</AppSpan>
                            <AppText color='#667085' topMargin='-0.3'>{userType}</AppText>
                        </CustomContainer>
                    </FlexRow>
                    <GridContainer 
                        minHeight='4' leftPadding='1.5' rightPadding='1.5' 
                        borderColor='#EAECF0' bgColor={isHover.user ? '#E7F6F5' : 'transparent'}
                        onMouseEnter={() => setIsHover({user: true})}
                        onMouseLeave={() => setIsHover({user: false})}
                        onClick={handleViewProfile}
                    >
                        <FlexRow gap='1' justifyContent='flex-start'>
                            <UserIcon className='icon-component' isHover={isHover.user} />
                            <AppText 
                                cursor='pointer' color={isHover.user ? '#0A756F' : '#344054'}
                            >
                                View Profile
                            </AppText>
                        </FlexRow>
                    </GridContainer>
                    <GridContainer 
                        minHeight='4' leftPadding='1.5' rightPadding='1.5' 
                        bgColor={isHover.logout ? '#E7F6F5' : 'transparent'}
                        onMouseEnter={() => setIsHover({logout: true})}
                        onMouseLeave={() => setIsHover({logout: false})}
                        onClick={handleConfirmLogout}
                    >
                        <FlexRow gap='1' justifyContent='flex-start'>
                            <LogoutIcon className='icon-component' isHover={isHover.logout}/>
                            <AppText 
                                cursor='pointer' color={isHover.user ? '#0A756F' : '#344054'}
                            >
                                Log out
                            </AppText>
                        </FlexRow>
                    </GridContainer>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}